import axios from 'axios'

class BillFactory {
  async bill (data: any) {
    try {
      const url = '/bills'
      const response = await axios.get(url, {
        params: {
          school_year_id: data.school_year_id,
          bill_type_id: data.bill_type_id
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async billDetail (id: any) {
    try {
      const url = `/bills/${id}`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async createBill (data: any) {
    try {
      const url = '/bills'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async updateBill (id: any, data: any) {
    try {
      const url = `/bills/${id}`
      const response = await axios.put(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async generateBill (id: any) {
    try {
      const url = `/bills/${id}/users`
      const response = await axios.post(url)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async generateBillByUserIds (id: any, student_ids: any) {
    try {
      const url = `/bills/${id}/users/user_ids`
      const data = {
        student_ids: student_ids
      }
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async downloadManualPaymentFileTemplate () {
    try {
      const url = '/bills/manual-payment/template'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: { }
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Template_Pelunasan_Manual.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async importManualPaymentFile (data: any) {
    try {
      const url = '/bills/manual-payment'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const billFactory = new BillFactory()
